import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { TfiEmail } from "react-icons/tfi";
import { FaSpinner } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Images } from "../../utils/images";
import { URLS } from "../../utils/ApiUrls";
import { errorPopup, successPopup } from "../../utils/ToasterMessage";
import "./login.css";

const LoginPage = () => {
  const [seePass, setSeePass] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${URLS.login}`, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const token = response.data?.data?.tokens?.access?.token;
      const user = response.data?.data?.user;

      if (token) {
        localStorage.setItem("access_token", token);
        localStorage.setItem("user_data", JSON.stringify(user));
        successPopup("Login successful!");
        navigate("/dashboard");
      } else {
        errorPopup("Invalid login credentials.");
      }
    } catch (error) {
      console.error("Login error:", error);
      errorPopup(
        error?.response?.data?.message || "Error logging in. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main_login">
      <div className="left-color-box">
        <div className="login_box">
          <img src={Images.kaamvala_logo} alt="Kaamvala Logo" className="auth-logo" />
          <h2 className="AuthTitle">Welcome Back, Admin!</h2>

          <form onSubmit={handleLogin}>
            <div className="input-group">
              <div className="input-label">
                <TfiEmail className="input-icon" /> Email
              </div>
              <input
                type="email"
                name="email"
                value={data.email}
                onChange={handleChange}
                className="form-input"
                placeholder="abc@gmail.com"
                required
              />
            </div>

            <div className="input-group">
              <div className="input-label">
                <img src={Images.Pad_Lock} alt="lock" className="padlock-icon" /> Password
              </div>
                <input
                  type={seePass ? "text" : "password"}
                  name="password"
                  value={data.password}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Enter Password"
                  required
                />
                <span className="eye-hover" onClick={() => setSeePass(!seePass)}>
                  {seePass ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            <div className="rememberMe">
              <label>
                <input type="checkbox" /> Remember Me
              </label>
              <Link to="/forgot-password" className="forgotPassword">
                Forgot Password?
              </Link>
            </div>

            <button type="submit" className="authbtn" disabled={isLoading}>
              {isLoading ? <FaSpinner className="spinner-icon" spin /> : "Log In"}
            </button>
          </form>
        </div>
      </div>

  
    </div>
  );
};

export default LoginPage;
